import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=08a1bfd9&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/style.css?vue&type=style&index=0&id=08a1bfd9&prod&scoped=true&lang=css&"
import style1 from "./Result.vue?vue&type=style&index=1&id=08a1bfd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1bfd9",
  null
  
)

export default component.exports